export enum APP_ENTITIES {
  ANSWER = 'answer',
  OPTION = 'option',
  QUESTION = 'question',
  SURVEY_TRANSACTION = 'survey-transaction',
  SURVEY = 'survey',
  QUOTA = 'quota',
  RULE = 'rule',
  PROJECT = 'project',
  CODEX_ENTRY = 'codex-entry',
  LIST = 'list',
  WIDGET = 'widget',
  DASHBOARD = 'dashboard',
  ACCESS_CODE = 'access-code',
  TEMPLATE = 'template',
  LANGUAGE = 'language',
  QUOTA_CELL = 'quota-cell',
  VARIABLE = 'variable',
  USER_GROUP = 'user-group',
  LANGUAGE_CODEX = 'language-codex',
  LANGUAGE_CODEX_ENTRY = 'language-codex-entry',
  PAGE_FIELD = 'page-field',
  MEDIA = 'media',
  PERMISSION = 'permission',
  USER = 'user',
  TARGET_LIST = 'target-list',
  TARGET_LIST_ITEM = 'target-list-item',
  COMMUNITY_SURVEY = 'community-survey',
}
